//Create Member by Super or Admin
import * as React from 'react';
import { useEffect, useState } from "react";
import {
  Box, Container, Grid, Typography, TextField, Button, MenuItem, Snackbar, Select, InputLabel, Alert, Autocomplete, CircularProgress, Paper, FormHelperText,
} from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useMutation } from "@apollo/client";
import { ADMIN_ADD_MEMBER_MUTATION } from "../graphql/mutations";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';

export default function FormComponent() {
  const [addMember, { loading: isLoading }] = useMutation(ADMIN_ADD_MEMBER_MUTATION);
  const storedUserType = localStorage.getItem("user_type");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    dob: "",
    state: "",
    district: "",
    city: "",
    pincode: "",
    identityProofType: "",
    identityProofNumber: "",
    panCard: "",
    panCardNumber: "",
    email: "",
    occupation: "",
    address: "",
    familyDetails: "",
    maritalStatus: "",
    star: "",
    raasi: "",
    kootram: "",
    kuladeivam: "",
  });

  const validateForm = () => {
    let newErrors = {};

    // Required fields validation
    if (!formData.firstName) {
      newErrors.firstName = "First Name is required";
    }

    if (!formData.lastName) {
      newErrors.Last_Name = "Last Name is required";
    }

    if (!formData.mobile) {
      newErrors.Mobile_Number = "Mobile Number is required";
    } else if (formData.mobile.length !== 10) {
      newErrors.Mobile_Number = "Mobile number must be exactly 10 digits";
    }

    if (!formData.city) {
      newErrors.City = "City is required";
    }

    if (!formData.district) {
      newErrors.district = "District is required";
    }

    if (!formData.state) {
      newErrors.state = "State is required";
    }

    if (!formData.pincode) {
      newErrors.pincode = "Pincode is required";
    } else if (formData.pincode.length !== 6) {
      newErrors.pincode = "Pincode must be exactly 6 digits";
    }

    // Address validation
    if (!formData.address) {
      newErrors.address = "Address is required";
    }

    // Occupation validation
    if (!formData.occupation) {
      newErrors.occupation = "Occupation is required";
    }

    // Family Details validation
    if (!formData.familyDetails) {
      newErrors.familyDetails = "Family Details are required";
    }

    // Marital Status validation
    if (!formData.maritalStatus) {
      newErrors.maritalStatus = "Marital Status is required";
    }

    if (storedUserType !== "admin") {
      // Payment Status validation
      if (!formData.paymentCompleted) {
        newErrors.paymentCompleted = "Payment Status is required";
      }

      // Only validate Transaction / Reference ID if payment is completed
      if (formData.paymentCompleted === "Paid") {
        if (!formData.transactionId || formData.transactionId.trim() === "") {
          newErrors.transactionId = "Transaction / Reference ID is required";
        } else if (!/^[a-zA-Z0-9\-_.]+$/.test(formData.transactionId)) {
          newErrors.transactionId =
            "Transaction / Reference ID can only contain letters, numbers, dashes, underscores, and dots";
        }
      }

      // Only validate Transaction date & time if payment is completed
      if (formData.paymentCompleted === "Paid") {
        if (!formData.transactionDateTime) {
          newErrors.transactionDateTime = "Transaction Date & Time is required";
        } else {
          const minValidDate = new Date("1900-01-01T00:00:00Z");
          const inputDate = new Date(formData.transactionDateTime);

          if (isNaN(inputDate.getTime()) || inputDate < minValidDate) {
            newErrors.transactionDateTime = "Transaction Date & Time must be after 01-01-1900";
          }
        }
      }

    }
    // Date of birth validation
    if (!formData.dob?.trim()) {
      newErrors.dob = "Date of Birth is required";
    } else {
      const dobError = validateDob(formData.dob);
      if (dobError) {
        newErrors.dob = dobError;
      }
    }

    // ID Proof Type validation
    if (!formData.identityProofType) {
      newErrors.identityProofType = "ID Proof selection is required";
    }

    // ID Proof validation - if a type is selected, number must be provided
    if (formData.identityProofType) {
      if (!formData.identityProofNumber) {
        newErrors.identityProofNumber = `${formData.identityProofType === 'aadhaar' ? 'Aadhaar' : 'License'} Number is required`;
      } else if (formData.identityProofType === 'aadhaar' && formData.identityProofNumber.length !== 12) {
        newErrors.identityProofNumber = "Aadhaar must be 12 digits and should not start with 0 or 1";
      } else if (formData.identityProofType === 'license' && !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)) {
        newErrors.identityProofNumber = "Driving License must be in format: TN7220251234567";
      }
    }

    // PAN Card selection validation
    if (!formData.panCard) {
      newErrors.panCard = "PAN Card selection is required";
    }

    // PAN Card validation - if Yes is selected, PAN number must be provided
    if (formData.panCard === "Yes") {
      if (!formData.panCardNumber) {
        newErrors.panCardNumber = "PAN Number is required";
      } else if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.panCardNumber)) {
        newErrors.panCardNumber = "PAN must be in the format: AAAAA9999A";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateDob = (dob) => {
    if (!dob?.trim()) return "Date of Birth is required";
    const selectedDate = new Date(dob);
    const today = new Date();
    const minDate = new Date("1900-01-01");
    const minAllowedDate = new Date();
    minAllowedDate.setFullYear(today.getFullYear() - 18);
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);
    minAllowedDate.setHours(0, 0, 0, 0);
    if (selectedDate >= today) return "Date of Birth must be in the past";
    if (selectedDate < minDate) return "Date of Birth must be after 01-01-1900";
    if (selectedDate > minAllowedDate) return "Minimum age required to register is 18 years.";
    return "";
  };
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Run validation
    if (!validateForm()) {
      // Create a more noticeable error message for validation failure
      return; // Stop submission if validation fails
    }

    setIsSubmitted(true);
    const inputVariables = {
      First_Name: formData.firstName,
      Last_Name: formData.lastName,
      Mobile_Number: formData.mobile,
      DOB: formData.dob,
      State: formData.state,
      District: formData.district,
      City: formData.city,
      Pincode: formData.pincode,

      ...(formData.email && { Email: formData.email }),
      ...(formData.occupation && { Occupation: formData.occupation }),
      ...(formData.address && { Address: formData.address }),
      ...(formData.maritalStatus && { Marital_Status: formData.maritalStatus }),
      ...(formData.identityProofType && { ID_Proof_Type: formData.identityProofType }),
      ...(formData.identityProofNumber && { ID_Proof_Number: formData.identityProofNumber }),
      ...(formData.panCard && { Pan_Card: formData.panCard }),
      ...(formData.panCardNumber && { Pan_Number: formData.panCardNumber }),
      ...(formData.star && { Star: formData.star }),
      ...(formData.raasi && { Raasi: formData.raasi }),
      ...(formData.kootram && { Kootram: formData.kootram }),
      ...(formData.kuladeivam && { Kuladeivam: formData.kuladeivam }),
      ...(formData.familyDetails && { Family_Details: formData.familyDetails }),

      // ✅ Payment Fields - Only if Payment Status is "Paid"
      ...(formData.paymentCompleted === "Paid" && {
        Payment_Status: "Paid",
        Payment_Method: "upi",
        Payment_Id: formData.transactionId,
        Payment_Date: formData.transactionDateTime, // ✅ Use selected datetime
      }),


      // ❌ If payment is not completed, optionally mark unpaid
      ...(formData.paymentCompleted === "Unpaid" && {
        Payment_Status: "Unpaid"
      }),
    };


    try {
      const { data } = await addMember({ variables: inputVariables });
      setOpenSnackbar(true);
      setSnackbarMessage("Member added successfully.");
      console.log("Member added:", data.addMember);
      window.location.href = '/manageusers';
    } catch (error) {
      console.error("Error adding member:", error);
      console.log("Member added:", inputVariables);
      const errorMessage = error?.message || "Something went wrong while adding member.";
      setSnackbarOpen(true);
      setSnackbarMessage(errorMessage);
    }
  };


  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  }

  // Handles radio button changes
  const handleRadioChange = (e) => {
    setFormData({ ...formData, identityProofType: e.target.value });
  };

  // Handles radio button changes
  const handlestatusChange = (e) => {
    setFormData({ ...formData, maritalStatus: e.target.value });
  };

  const handlePanChange = (e) => {
    const value = e.target.value;
    setFormData({
      ...formData,
      panCard: value,
      panCardNumber: value === "No" ? "" : formData.panCardNumber
    });

    if (value === "No") {
      setOpenDialog(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    // Get mobile number & user type from localStorage
    const mobile = localStorage.getItem("mobile");
    const userType = localStorage.getItem("user_type");

    if (!mobile || !userType) {
      console.error("Mobile number or user type not found in localStorage");
      return;
    }

    window.scrollTo(0, 0);
  }, []);


  const districts = ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
    "Dindigul", "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur", "Karaikal",
    "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal",
    "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
    "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Thiruchirappalli", "Tirunelveli", "Tirupathur",
    "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar", "Other"
  ];

  const states = ["Tamil Nadu", "Other"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDateTimeChange = (newValue) => {
    if (dayjs(newValue).isValid()) {
      setFormData((prev) => ({
        ...prev,
        transactionDateTime: newValue.toISOString(),
      }));
    } else {
      // Optionally clear or ignore invalid input
      setFormData((prev) => ({
        ...prev,
        transactionDateTime: "",
      }));
    }
  };

  return (
    <Box sx={{ backgroundColor: "#f8f9e9", py: 6, top: "150px", bottom: "150px" }}>
      <Container>
        <Typography variant="h5" sx={{ fontWeight: "500", color: "#2A289C", textAlign: "center", fontSize: "32px" }} gutterBottom>
          Member Registration
        </Typography>

        <form onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
              e.preventDefault(); // Prevent Enter key from submitting the form
            }
          }}
        >
          <Grid item xs={12} md={6}>
            <Box
              component="form"
              sx={{
                backgroundColor: "#f8f9e9",
                padding: 4,
                borderRadius: "8px",
                borderColors: "#CEC35E",
                boxShadow: 3,
                width: "95%",
                maxWidth: "890px",
                margin: "0 auto",
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>First Name</FormLabel>
                  <TextField
                    size="small"
                    placeholder="Enter your First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                    error={!!errors.firstName}
                    helperText={errors.firstName || ""}
                    required
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Last Name</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                    error={!!errors.Last_Name}
                    helperText={errors.Last_Name || ""}
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Date of Birth</FormLabel>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format="YYYY-MM-DD"
                      value={formData.dob ? dayjs(formData.dob, "YYYY-MM-DD") : null}
                      onChange={(date) =>
                        setFormData({ ...formData, dob: date ? date.format("YYYY-MM-DD") : "" })
                      }
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          error: !!errors.dob,
                          helperText: errors.dob || "",
                          required: true,
                        },
                        popper: {
                          sx: {
                            "& .MuiPaper-root": {
                              backgroundColor: "#f8f9e9",
                            },
                          },
                        },
                      }}
                      disableFuture
                      minDate={dayjs("1900-01-01")}
                      maxDate={dayjs().subtract(18, "year")}
                      required
                    />
                  </LocalizationProvider>
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Mobile Number</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your Mobile Number"
                    type="text"
                    name="mobile"
                    value={formData.mobile}
                    onChange={(e) => {
                      const inputValue = e.target.value.replace(/\D/g, "");
                      if (inputValue.length <= 10) {
                        setFormData({ ...formData, mobile: inputValue });
                      }
                    }}
                    error={!!errors.Mobile_Number}
                    helperText={errors.Mobile_Number || ""}
                    required
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>State</FormLabel>
                  <Autocomplete
                    options={states}
                    value={formData.state}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setFormData({ ...formData, state: newValue });
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder='Select your State'
                        required
                        error={!!errors.state}
                        helperText={errors.state || ""}
                        sx={{
                          backgroundColor: "#f8f9e9",
                          "& .MuiInputBase-input": {
                            caretColor: "transparent",
                            cursor: "pointer",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            backgroundColor: "#f8f9e9",
                            px: 1,
                            transform: "translate(14px, -6px) scale(0.75)",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          readOnly: false,
                        }}
                      />
                    )}
                    disableClearable
                    fullWidth
                    autoHighlight
                    required
                    PaperComponent={(props) => (
                      <Paper
                        {...props}
                        sx={{
                          backgroundColor: "#f8f9e9",
                        }}
                      />
                    )}
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>District</FormLabel>
                  <Autocomplete
                    options={districts}
                    value={formData.district}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setFormData({ ...formData, district: newValue });
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder='Select your District'
                        required
                        error={!!errors.district}
                        helperText={errors.district || ""}
                        sx={{
                          backgroundColor: "#f8f9e9",
                          "& .MuiInputBase-input": {
                            caretColor: "transparent",
                            cursor: "pointer",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            backgroundColor: "#f8f9e9",
                            px: 1,
                            transform: "translate(14px, -6px) scale(0.75)",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          readOnly: false,
                        }}
                      />
                    )}
                    disableClearable
                    fullWidth
                    autoHighlight
                    required
                    PaperComponent={(props) => (
                      <Paper
                        {...props}
                        sx={{
                          backgroundColor: "#f8f9e9",
                        }}
                      />
                    )}
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>City</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your City"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                    error={!!errors.City}
                    helperText={errors.City || ""}
                    required
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Pincode</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your Pincode"
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={(e) => {
                      const inputValue = e.target.value.replace(/\D/g, "");
                      if (inputValue.length <= 6) {
                        setFormData({ ...formData, pincode: inputValue });
                      }
                    }}
                    error={!!errors.pincode}
                    helperText={errors.pincode || ""}
                    required
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Address</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    inputProps={{ maxLength: 250, pattern: "[A-Za-z0-9,./\\-\\s]*" }}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z0-9,./\-\s]/g, '')}
                    error={!!errors.address}
                    helperText={errors.address || ""}
                    required
                  />
                </FormControl>

                <FormControl fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Email ID</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your Email ID"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    inputProps={{ maxLength: 50 }}
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Occupation</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your Occupation"
                    type="text"
                    name="occupation"
                    value={formData.occupation}
                    onChange={handleChange}
                    inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                    error={!!errors.occupation}
                    helperText={errors.occupation || ""}
                    required
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Family Details</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Number of Family Members"
                    name="familyDetails"
                    value={formData.familyDetails}
                    onChange={handleChange}
                    inputProps={{ maxLength: 70, pattern: "[A-Za-z0-9, ]*" }}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z0-9, ]/g, '')}
                    error={!!errors.familyDetails}
                    helperText={errors.familyDetails || ""}
                    required
                  />
                </FormControl>

                <FormControl fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Star</FormLabel>
                  <Autocomplete
                    options={[
                      "Ashwini", "Bharani", "Krithikai", "Rohini", "Mirgasheersham", "Thiruvaathirai", "Punarpoosam", "Poosam",
                      "Aayilyam", "Makam", "Pooram", "Uthiram", "Hastham", "Chithirai", "Swaathi", "Visaakam",
                      "Anusham", "Kettai", "Moolam", "Pooraadam", "Uthiraadam", "Thiruvonam", "Avittam",
                      "Chathayam/Sadayam", "Poorattathi", "Uthirattathi", "Revathi"
                    ]}
                    value={formData.star || ""}
                    onChange={(event, newValue) => {
                      setFormData({ ...formData, star: newValue });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder='Select your Star'
                        sx={{
                          backgroundColor: "#f8f9e9",
                          "& .MuiInputBase-input": {
                            caretColor: "transparent",
                            cursor: "pointer",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            backgroundColor: "#f8f9e9",
                            px: 1,
                            transform: "translate(14px, -6px) scale(0.75)",
                          },
                        }}
                      />
                    )}
                    fullWidth
                    disableClearable
                    autoHighlight
                    PaperComponent={(props) => (
                      <Paper
                        {...props}
                        sx={{
                          backgroundColor: "#f8f9e9",
                        }}
                      />
                    )}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Raasi</FormLabel>
                  <Autocomplete
                    options={[
                      "Mesham", "Risabham", "Mithunam", "Kadagam", "Simmam", "Kanni",
                      "Thulam", "Viruchigam", "Dhanushu", "Magaram", "Kumbham", "Meenam"
                    ]}
                    value={formData.raasi || ""}
                    onChange={(event, newValue) => {
                      setFormData({ ...formData, raasi: newValue });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder='Select your Raasi'
                        sx={{
                          backgroundColor: "#f8f9e9",
                          "& .MuiInputBase-input": {
                            caretColor: "transparent",
                            cursor: "pointer",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            backgroundColor: "#f8f9e9",
                            px: 1,
                            transform: "translate(14px, -6px) scale(0.75)",
                          },
                        }}
                      />
                    )}
                    fullWidth
                    disableClearable
                    autoHighlight
                    PaperComponent={(props) => (
                      <Paper
                        {...props}
                        sx={{
                          backgroundColor: "#f8f9e9",
                        }}
                      />
                    )}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Gothram</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your Gothram"
                    name="kootram"
                    value={formData.kootram}
                    onChange={handleChange}
                    inputProps={{ maxLength: 50, pattern: "[A-Za-z]*" }}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Kuladeivam</FormLabel>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter your Kuladeivam"
                    name="kuladeivam"
                    value={formData.kuladeivam}
                    onChange={handleChange}
                    inputProps={{ maxLength: 50, pattern: "[A-Za-z]*" }}
                    onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                  />
                </FormControl>

                <FormControl required fullWidth sx={{ my: 1 }}>
                  <FormLabel sx={{ mb: 1, textAlign: 'left' }}>Marital Status</FormLabel>
                  <Autocomplete
                    options={["Single", "Married"]}
                    value={formData.maritalStatus || ""}
                    onChange={(event, newValue) => {
                      setFormData({ ...formData, maritalStatus: newValue });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder='Select your Marital Status'
                        required
                        error={!!errors.maritalStatus}
                        helperText={errors.maritalStatus || ""}
                        sx={{
                          backgroundColor: "#f8f9e9",
                          "& .MuiInputBase-input": {
                            caretColor: "transparent",
                            cursor: "pointer",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                          sx: {
                            backgroundColor: "#f8f9e9",
                            px: 1,
                            transform: "translate(14px, -6px) scale(0.75)",
                          },
                        }}
                      />
                    )}
                    fullWidth
                    disableClearable
                    autoHighlight
                    required
                    PaperComponent={(props) => (
                      <Paper
                        {...props}
                        sx={{
                          backgroundColor: "#f8f9e9",
                        }}
                      />
                    )}
                  />
                </FormControl>

                {/* ID Proof Section */}
                <Box sx={{ my: 1 }}>
                  <FormControl component="fieldset" required fullWidth>
                    <FormLabel
                      sx={{
                        mb: 1,
                        textAlign: 'left',
                        display: 'block',
                        width: '100%'
                      }}
                    >
                      ID Proof
                    </FormLabel>
                    <RadioGroup
                      row
                      name="identityProofType"
                      value={formData.identityProofType}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel value="aadhaar" control={<Radio sx={{ color: "gray" }} />} label="Aadhaar" />
                      <FormControlLabel value="license" control={<Radio sx={{ color: "grey" }} />} label="License" />
                    </RadioGroup>
                    {errors.identityProofType && (
                      <FormHelperText error>{errors.identityProofType}</FormHelperText>
                    )}
                  </FormControl>

                  {/* ID Proof Number Field */}
                  {formData.identityProofType && (
                    <FormControl fullWidth required sx={{ my: 1 }}>
                      <FormLabel
                        sx={{
                          mb: 1,
                          textAlign: 'left',
                          display: 'block',
                          width: '100%',
                        }}
                      >
                        {formData.identityProofType === "aadhaar"
                          ? "Aadhaar Number"
                          : "License Number"}
                      </FormLabel>

                      <TextField
                        fullWidth
                        size="small"
                        type="text"
                        name="identityProofNumber"
                        value={formData.identityProofNumber}
                        onChange={(e) => {
                          const value =
                            formData.identityProofType === "aadhaar"
                              ? e.target.value.replace(/\D/g, "").slice(0, 12)
                              : e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15);
                          setFormData((prev) => ({ ...prev, identityProofNumber: value }));
                        }}
                        error={!!errors.identityProofNumber}
                        helperText={errors.identityProofNumber || ""}
                        placeholder={
                          formData.identityProofType === "aadhaar"
                            ? "Enter your Aadhaar Number"
                            : "Enter your License Number"
                        }
                        inputProps={{
                          maxLength: formData.identityProofType === "aadhaar" ? 12 : 15,
                        }}
                      />
                    </FormControl>
                  )}

                </Box>

                {/* PAN Card Section */}
                <Box sx={{ my: 1 }}>
                  <FormControl component="fieldset" required fullWidth>
                    <FormLabel
                      sx={{
                        mb: 1,
                        textAlign: 'left',
                        display: 'block',
                        width: '100%'
                      }}
                    >
                      Pan Card
                    </FormLabel>
                    <RadioGroup
                      row
                      name="panCard"
                      value={formData.panCard}
                      onChange={handlePanChange}
                    >
                      <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                      <FormControlLabel value="No" control={<Radio />} label="No" />
                    </RadioGroup>
                    {errors.panCard && (
                      <FormHelperText error>{errors.panCard}</FormHelperText>
                    )}
                  </FormControl>

                  {/* PAN Number Field */}
                  {formData.panCard === "Yes" && (
                    <FormControl fullWidth required sx={{ my: 1 }}>
                      <FormLabel sx={{ mb: 1, textAlign: 'left' }}>
                        PAN Number
                      </FormLabel>
                      <TextField
                        size="small"
                        placeholder="Enter your PAN Number"
                        name="panCardNumber"
                        value={formData.panCardNumber}
                        onChange={handleChange}
                        error={!!errors.panCardNumber}
                        helperText={errors.panCardNumber || ""}
                        inputProps={{ maxLength: 10 }}
                        onInput={(e) =>
                          (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10))
                        }
                      />
                    </FormControl>
                  )}

                </Box>

                {/* Dialog when PAN Card is No */}
                <Dialog open={openDialog} onClose={handleCloseDialog}>
                  <DialogContent>
                    <Typography variant="body5" sx={{ mt: 1 }}>
                      Please note: The Membership ID card will only be generated for the user if you select <em>'Yes'</em> and provide user's PAN Card number.<br />
                      If you select <em>'No'</em>, the ID card will <strong>not</strong> be generated for the user.
                    </Typography>
                  </DialogContent>
                  <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                      onClick={handleCloseDialog}
                      variant="contained"
                      sx={{
                        backgroundColor: "#2A289C",
                        color: "#fff",
                        borderRadius: '999px',
                        "&:hover": {
                          backgroundColor: "#1a1970",
                        },
                        px: 4,
                        py: 1,
                      }}
                    >
                      I understand
                    </Button>

                  </DialogActions>
                </Dialog>
                {storedUserType === "superuser" && (
                  <Box sx={{ my: 1 }}>
                    {/* Payment Status */}
                    <FormControl component="fieldset" required fullWidth>
                      <FormLabel
                        sx={{
                          mb: 1,
                          textAlign: 'left',
                          display: 'block',
                          width: '100%',
                        }}
                        required
                      >
                        Payment Status
                      </FormLabel>
                      <RadioGroup
                        row
                        name="paymentCompleted"
                        value={formData.paymentCompleted}
                        onChange={handleChange}
                      >
                        <FormControlLabel value="Paid" control={<Radio />} label="Paid" />
                        <FormControlLabel value="Unpaid" control={<Radio />} label="Unpaid" />
                      </RadioGroup>
                      {errors.paymentCompleted && (
                        <FormHelperText error>{errors.paymentCompleted}</FormHelperText>
                      )}
                    </FormControl>

                    {/* Transaction / Reference ID */}
                    {formData.paymentCompleted === "Paid" && (
                      <FormControl fullWidth required sx={{ my: 1 }}>
                        <FormLabel sx={{ mb: 1, textAlign: 'left' }}>
                          Transaction / Reference ID
                        </FormLabel>
                        <TextField
                          size="small"
                          placeholder="Enter your Transaction / Reference ID"
                          name="transactionId"
                          value={formData.transactionId}
                          onChange={handleChange}
                          error={!!errors.transactionId}
                          helperText={errors.transactionId || ""}
                          inputProps={{ maxLength: 50 }}
                        />
                      </FormControl>
                    )}

                    {/* Transaction Date & Time */}
                    {formData.paymentCompleted === "Paid" && (
                      <FormControl required fullWidth sx={{ my: 1 }}>
                        <FormLabel sx={{ mb: 1, textAlign: 'left' }}>
                          Transaction Date & Time
                        </FormLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            format="YYYY-MM-DD HH:mm"
                            value={formData.transactionDateTime ? dayjs(formData.transactionDateTime) : null}
                            onChange={handleDateTimeChange}
                            timeSteps={{ minutes: 1 }} // ✅ Proper way to show 1-minute intervals in dropdown
                            ampm={true} // or true if you prefer 12-hour format
                            views={['year', 'month', 'day', 'hours', 'minutes']}
                            allowKeyboardControl
                            disableFuture={true}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: 'small',
                                error: !!errors.transactionDateTime,
                                helperText: errors.transactionDateTime || '',
                                required: true,
                              },
                              popper: {
                                sx: {
                                  '& .MuiPaper-root': {
                                    backgroundColor: '#f8f9e9',
                                  },
                                },
                              },
                            }}
                          />

                        </LocalizationProvider>
                      </FormControl>
                    )}
                  </Box>
                )}
              </div>
            </Box>
            <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
              <Grid item>
                {isLoading ? (
                  <CircularProgress color="success" />
                ) : (
                  <Button type="submit" variant="contained" onClick={handleSubmit} fullWidth style={{ backgroundColor: "green", color: "white", borderRadius: '999px' }}>
                    Create Member
                  </Button>
                )}
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  fullWidth
                  style={{ backgroundColor: "#E52029", color: "white", borderRadius: '999px' }}
                  onClick={() => {
                    navigate("/manageusers");
                    window.scrollTo(0, 0);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>

              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>
      {/* Snackbar Alert */}
      <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }} >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
          Member Created Successfully!
        </Alert>
      </Snackbar>
      <Snackbar open={snackbarOpen} autoHideDuration={10000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>{snackbarMessage}</Alert></Snackbar>
    </Box>
  );
}